export enum IconSize {
  xs = 'fa-xs',
  '2xs' = 'fa-2xs',
  sm = 'fa-sm',
  lg = 'fa-lg',
  xl = 'fa-xl',
  '2xl' = 'fa-2xl',
  '1x' = 'fa-1x',
  '2x' = 'fa-2x',
  '3x' = 'fa-3x',
  '4x' = 'fa-4x',
  '5x' = 'fa-5x',
  '6x' = 'fa-6x',
  '7x' = 'fa-7x',
  '8x' = 'fa-8x',
  '9x' = 'fa-9x',
  '10x' = 'fa-10x',
}
